import axios from '@/lib/axios/axios';

import Order from '../../types/api/order/Order';

// import { MSW_URL } from '../../config/config';

export default {
    /**
     * A get request to the orders endpoint will return a paginated list of all orders in the system, scoped
     * to user.
     * You can also limit the return to recent orders by using the recent parameter and providing the number
     * of days from the current date. e.g. ?recent=14 will return any orders in the last 14 days that qualify
     * (not in draft status).
     * @param {number} page - Current page of orders to view.
     * @param {number} perPage - Number of orders per page to show.
     * @param {number} recent - Number of days to class as recent orders.
     * @param {string} status - Order statuses to get e.g.('new,fulfilled').
     * @param {object} - Axios request response.
     */
    getAllOrders: async (page = null, perPage = null, recent = null, status = null, excluded = 'draft') => {
        const queries = [];

        if (page !== null) queries.push(`page=${page}`);
        if (perPage !== null) queries.push(`perPage=${perPage}`);
        if (recent !== null) queries.push(`recent=${recent}`);
        if (status !== null) queries.push(`status=${status}`);
        if (excluded !== null) queries.push(`excluded=${encodeURIComponent(excluded)}`);

        const queryString = queries.length ? `?${queries.join('&')}` : '';
        return axios.get(`/orders${queryString}`);
    },

    getOrderVerificationType: async (uuid: string) => axios.get(`/orders/${uuid}/identity-check`),

    /**
     * Returns a specified order.
     * @param {string} uuid - Uniwue ID of the order to get.
     * @param {number} withSegments - 1 or 0 on whether or not to include segments.
     */
    getOrder: async (uuid: string, withSegments = 0) => axios.get<{ data: Order }>(`/orders/${uuid}?withSegments=${withSegments}`),

    /**
     * Returns a specified order's notes.
     * @param {string} uuid - Uniwue ID of the order notes to get.
     */
    getOrderNotes: async (uuid: string) => axios.get(`/orders/${uuid}/notes`),

    /**
     * Updates the delivery address on an order
     * @param {string} uuid - Unique ID of the order to update.
     * @param {object} patchData - The data to be sent in the patch request.
     */
    updateOrderDeliveryAddress: async (uuid: string, patchData: any) => axios.patch(`/orders/${uuid}/change-delivery-address`, patchData),
};
